<svg xmlns="http://www.w3.org/2000/svg" width="92" height="88" viewBox="0 0 92 88">
  <defs>
    <linearGradient id="a" x1="50%" x2="50%" y1="100%" y2="0%">
      <stop offset="0%" stop-color="#FFF"/>
      <stop offset="100%" stop-color="#FFF"/>
    </linearGradient>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <path fill="url(#a)" stroke="#D9DDDF" stroke-width="2.25" d="M1.125 1.125h89.75v85.75H1.125z"/>
    <path stroke="#0069C4" stroke-linecap="square" stroke-width="2.5" d="M62.607 20l-.214 50M62.5 44.5l-31.393.393"/>
    <g fill="#FFF" stroke="#313131" stroke-width="1.395">
      <path d="M38.644 40.176l7.88 4.479-7.88 4.479zM54.514 49.134l-7.88-4.479 7.88-4.479z"/>
    </g>
    <g stroke="#313131" transform="translate(56 47)">
      <path fill="#FFF" stroke-width="1.395" d="M10.824 4.644l-4.479 7.88-4.479-7.88zM1.866 20.514l4.479-7.88 4.479 7.88z"/>
      <path stroke-linecap="square" stroke-width="1.5" d="M7.5 12.5h6"/>
      <circle cx="15" cy="12" r="3" fill="#FFF" stroke-width="1.305"/>
    </g>
    <path stroke="#D90338" stroke-linecap="square" stroke-width="2.5" d="M29.557 20l-.114 50"/>
    <g stroke="#313131">
      <circle cx="5.831" cy="5.837" r="5.472" fill="#FFF" stroke-width="1.5" transform="rotate(90 5 30)"/>
      <path stroke-linecap="square" stroke-width="1.4" d="M34 32l-5-5-4.5 4.5"/>
    </g>
  </g>
</svg>
